module.exports = __webpack_public_path__ + "static/img/アセット 11@2x.b0fead0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 11@2x.png
// module id = 2UW1
// module chunks = 1